// extracted by mini-css-extract-plugin
export default {"payment-page":"PaymentPage_payment-page__ab1T7"};